// extracted by mini-css-extract-plugin
export default {"pageShell":"AdminSupervisors_pageShell__ecVCq"};